export const validAdditional = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "additional_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if(data.length > 256){
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "description":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        }else if(data.length > 256){
          error[namespace] = translate("COMMON:MAX_LENGTH", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "to_menu":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    default:
      break;
  }
  return error;
};
